import React, { useMemo } from "react";
import Table from "../Table/Table";
import { formatARS } from "../../utils/currency";

const statusPill = (name = "") => {
  const n = String(name);
  if (n === "Pendiente") return { bg: "bg-yellow-500", txt: "text-white", br: "border-yellow-300", dot: "bg-yellow-900" };
  if (n === "Aprobada")  return { bg: "bg-custom-green-ccard-1",  txt: "text-white",  br: "border-green-300",  dot: "bg-green-900"  };
  if (n === "Rechazada") return { bg: "bg-red-500",    txt: "text-white",    br: "border-red-300",    dot: "bg-red-900"    };
  return { bg: "bg-gray-100", txt: "text-gray-700", br: "border-gray-300", dot: "bg-gray-500" };
};


const getColumns = (ApprobeApplications) => [
  {
    Header: "ID",
    accessor: "id",
    width: "50px",
  },
  {
    Header: "Nombre",
    accessor: "Employee.screenname",
  },
  {
    Header: "Fecha de Solicitud",
    accessor: "createdAt",
    Cell: ({ value }) => {
      return value
        ? new Date(value).toLocaleDateString("es-ES", { timeZone: "UTC" })
        : "";
    },
  },
  {
    Header: "Usuario que Solicita",
    accessor: "Requester.screenname",
  },
  {
    Header: "Usuario que Autoriza",
    accessor: "Approver.screenname",
  },
  {
    Header: "Usuario que Gestiona",
    accessor: "Manager.screenname",
  },
  {
    Header: "Producto",
    accessor: (row) => row.productDescription || row.Stock?.description || row.details || "-",
    width: "250px",
  },
  {
    Header: "Precio contado público",
    accessor: "Stock.cash_price",
    Cell: ({ value }) => value != null ? formatARS(value) : "-",
  },
{
    Header: "Estado",
    id: "estado",
    accessor: (row) => row?.Status?.name ?? "Pendiente",
    Cell: ({ value }) => {
      const s = statusPill(value);
      return (
        <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-lg border font-bold ${s.bg} ${s.txt} ${s.br}`}>
          <span className={`h-2 w-2 rounded-full ${s.dot}`} />
          {value ?? "Pendiente"}
        </span>
      );
    },
    width: "160px",
  },
{
  Header: "Aprobar / Rechazar",
  id: "acciones",            // 👈 agrega este id
  accessor: "conform",
  Cell: ({ row }) => {
    const statusName = row.original?.Status?.name ?? "Pendiente";
    if (statusName !== "Pendiente") return <span className="text-gray-400">—</span>;
    return (
      <div className="flex justify-center items-center h-full">
        <button
          className="text-white hover:bg-custom-green-ccard-2 border-2 rounded-lg p-2 bg-custom-green-ccard-1"
          onClick={() => ApprobeApplications(row.original.id)}
        >
          Aceptar / Rechazar
        </button>
      </div>
    );
  },
  width: "170px",
}

];



const TmcApplicationsList = ({ data, onOpen,ApprobeApplications, canManageApplications, mode }) => {
  const columns = useMemo(() => getColumns(ApprobeApplications), [ApprobeApplications]);

  const columnsByRole = useMemo(() => {
    return canManageApplications
      ? columns
      : columns.filter((c) => c.id !== "acciones" && c.Header !== "Aprobar / Rechazar");
  }, [columns, canManageApplications]);

  return (
    <div className="relative flex flex-col gap-4 bg-slate-100 bg-cover bg-center bg-no-repeat h-screen">
      {onOpen && <div className="flex justify-end absolute top-0 right-0 mt-1 z-10">
        <div className="flex justify-end">
          <button
            onClick={() => onOpen()}
            className="bg-custom-green-ccard-1 hover:bg-custom-green-ccard-2 font-bold text-white py-3 px-4 rounded-lg"
          >
            Nueva solicitud
          </button>
        </div>
      </div>}
      <h1 className="text-2xl font-semibold text-slate-800 pr-48">
        {mode === "manage" ? "Solicitudes de compra TMC" : "Mis solicitudes de compra TMC"}
      </h1>
      <Table columns={columnsByRole} data={data} />
    </div>
  );
};

export default TmcApplicationsList;
